import PinIcon from "@mui/icons-material/Pin";
import { Fade, IconButton, Tooltip } from "@mui/material";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import images from "../assets/images";
import Loading from "../common/loading/Loading";
import Spotlight from "../common/spotlight/Spotlight";
import Button from "../framework/Button";
import GlobalContext from "../framework/GlobalContext";
import Modal from "../framework/modal/Modal";
import Shortcut from "../framework/Shortcut";
import Tab from "../framework/tab/Tab";
import { configureInitialState } from "../framework/tab/tabUtils";
import {
  CONFIGURATION_TAB,
  GENERATE_OTP_TAB,
} from "../framework/tab/tabUtilsConstants";
import { displayToast } from "../framework/toast/toastUtils";
import { searchCategories } from "../services/category-services";
import nodeClient, { BYPASS_ERROR_URLS } from "../services/node-client";
import { changeAdminPassword } from "../services/user-service";
import { isEmpty } from "../utils/utils";
import ChangePassword from "./changePassword";
import classes from "./Home.module.css";
import { initial_state_users } from "./users/constant";
const Home = () => {
  const {
    tabs,
    activeTabIndex,
    configData: { SET_MAXIMUM_TABS = 10 },
  } = useSelector((state) => state.commonReducer);

  const {
    goToNextTab,
    setGoToNextTab,
    goToPrevTab,
    setGoToPrevTab,
    addNewTab,
    setAddNewTab,
    goToTab,
    setGoToTab,
    closeCurrentTab,
    setCloseCurrentTab,
    // showAddProductAutocomplete,
    // setShowAddProductAutocomplete,
    // showGlobalShortcuts,
    // setShowGlobalShortcuts,
    showSpotlight,
    setShowSpotlight,
    // setBarcode,
    showLoading,
    setShowLoading,
    setCurrentComponent,
    currentComponent,
  } = useContext(GlobalContext);

  const dispatch = useDispatch();
  const [tabList, setTabList] = useState(tabs);
  const [selectedIndex, setSelectedIndex] = useState(activeTabIndex);
  const [nextTab, setNextTab] = useState(false);
  const [prevTab, setPrevTab] = useState(false);
  const [closeTab, setCloseTab] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const changePasswordRef = useRef(null);
  const saveChangedPasswordRef = useRef(false);
  const { spotlight, logout, changePassword } = images;
  const navigate = useNavigate();
  const showSpotlightHandler = (e) => {
    setShowSpotlight(true);
  };
  const logoutHandler = useCallback(
    (e) => {
      sessionStorage.clear();
      setAddNewTab(null);
      navigate("/login");
    },
    [navigate, setAddNewTab]
  );

  const changePasswordHandler = useCallback(() => {
    setShowChangePassword((prev) => !prev);
  }, []);

  const titleBarStartItems = [
    <div
      key="spotlight"
      className={classes["title-bar-icons"]}
      onClick={showSpotlightHandler}
    >
      <img src={spotlight} alt="spotlight" />
    </div>,
  ];
  const titleBarEndItems = [
    <div key="changePassword" className={classes["title-bar-icons"]}>
      <Tooltip
        title="Change Password"
        arrow
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
      >
        <img
          src={changePassword}
          alt="changePassword"
          onClick={changePasswordHandler}
        />
      </Tooltip>
    </div>,
    <div key="generate_otp" className={`${classes["title-bar-icons"]}`}>
      <Tooltip
        key="generate_otp"
        title={
          <div
            style={{
              display: "flex",
              gap: "2px",
              alignItems: "center",
              height: "25px",
            }}
          >
            Generate OTP
          </div>
        }
        arrow
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
      >
        <IconButton
          sx={{ padding: 0 }}
          onClick={() => setAddNewTab({ component: GENERATE_OTP_TAB })}
        >
          <PinIcon
            sx={{
              background: "#020002",
              borderRadius: "4px",
              color: "#fff",
              padding: "2px",
              fontSize: 30,
            }}
          />
        </IconButton>
      </Tooltip>
    </div>,
    <div key="logout" className={classes["title-bar-icons"]}>
      <img src={logout} alt="logout" onClick={logoutHandler} />
    </div>,
  ];

  const closeTabHandler = useCallback(
    (updated_tabs, newIndex, deleted_tab) => {
      setCloseTab(false);
      setSelectedIndex(newIndex);
      if (updated_tabs?.length === 0) {
        updated_tabs = [initial_state_users];
        setTabList(updated_tabs);
      }
      dispatch({ type: "update_tabs", payload: updated_tabs });
      dispatch({ type: "update_active_tab_index", payload: newIndex });
    },
    [dispatch]
  );

  const updatedTabsHandler = useCallback(
    (updated_tabs, newIndex) => {
      if (updated_tabs)
        dispatch({ type: "update_tabs", payload: updated_tabs });
      if (!isEmpty(newIndex)) {
        //updated by alston
        dispatch({ type: "update_active_tab_index", payload: newIndex });
      }
    },
    [dispatch]
  );

  // const getItemTypeOptions = useCallback(async () => {
  //   const response = await searchItemType();
  //   const updatedResponse = response?.rows.map((item) => {
  //     return {
  //       id: item.itemGroupId,
  //       label: item.itemGroupName,
  //     };
  //   });
  //   dispatch({
  //     type: "update_item_type_options",
  //     payload: updatedResponse,
  //   });
  // }, [dispatch]);

  const getCategoyOptions = useCallback(async () => {
    const response = await searchCategories();
    dispatch({
      type: "update_category_options",
      payload: response?.rows,
    });
  }, [dispatch]);

  const closeChangePasswordHandler = useCallback(() => {
    setShowChangePassword(false);
    setCurrentComponent(tabs[activeTabIndex]?.currentFocus?.id);
  }, [activeTabIndex, setCurrentComponent, tabs]);

  const validateChangePasswordForm = useCallback((formData) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$#!%*?&]{8,}$/;
    if (!formData) {
      displayToast({
        type: "error",
        title: "Please fill all the fields",
      });
      return false;
    }
    if (!formData?.user) {
      displayToast({
        type: "error",
        title: "Please select a user",
      });
      return false;
    }
    if (isEmpty(formData?.currentPassword)) {
      displayToast({
        type: "error",
        title: "Please enter current password",
      });
      return false;
    }
    if (isEmpty(formData?.newPassword)) {
      displayToast({
        type: "error",
        title: "Please enter new password",
      });
      return false;
    }
    if (!regex.test(formData?.newPassword)) {
      displayToast({
        type: "error",
        title: (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              New Password must be alphanumeric.
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              New Password must be atleast 8 characters in length.
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              New Password must contain atleast one uppercase letter.
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              New Password must contain atleast one lowercase letter.
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              New Password must contain atleast one special character from
              (@$!%*?&).
            </div>
          </div>
        ),
      });
      return false;
    }
    if (isEmpty(formData?.confirmPassword)) {
      displayToast({
        type: "error",
        title: "Please enter confirm password",
      });
      return false;
    }
    if (formData?.newPassword !== formData?.confirmPassword) {
      displayToast({
        type: "error",
        title: "New password and confirm password do not match",
      });
      return false;
    }
    return true;
  }, []);

  const changeAdminPasswordHandler = useCallback(
    async (data) => {
      const payload = {
        ...data,
        _id: data?.user?._id,
      };
      delete payload?.user;
      const response = await changeAdminPassword(payload);
      if (response?.status === "success") {
        closeChangePasswordHandler();
        if (response?.result?.username === sessionStorage.getItem("username")) {
          logoutHandler();
          displayToast({
            type: "success",
            title: "Password changed successfully , Please login again",
          });
        } else {
          displayToast({
            type: "success",
            title: "Password changed successfully",
          });
        }
      }
    },
    [closeChangePasswordHandler, logoutHandler]
  );

  const changePasswordKeyListener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const ctrlKey = e.ctrlKey;
    if (ctrlKey && key === "s") {
      saveChangedPasswordRef.current.click();
    }
  }, []);

  useEffect(() => {
    if (goToNextTab) {
      setNextTab(true);
      setGoToNextTab(false);
    }
  }, [activeTabIndex, goToNextTab, setGoToNextTab, tabs]);

  useEffect(() => {
    if (goToPrevTab) {
      setPrevTab(true);
      setGoToPrevTab(false);
    }
  }, [activeTabIndex, goToPrevTab, setGoToPrevTab]);

  useEffect(() => {
    if (closeCurrentTab) {
      setCloseTab(true);
      setCloseCurrentTab(false);
    }
  }, [closeCurrentTab, setCloseCurrentTab]);

  useEffect(() => {
    if (goToTab !== null && tabs.length > goToTab) {
      setSelectedIndex(goToTab);
      setGoToTab(null);
    }
  }, [goToTab, setGoToTab, tabs]);

  useEffect(() => {
    if (addNewTab?.component) {
      if (SET_MAXIMUM_TABS === tabs.length) {
        displayToast({ type: "error", title: "Max tab limit reached." });
        setAddNewTab(null);
        return;
      }
      let updated_tabs = [...tabs];
      const new_tab = configureInitialState(addNewTab.component);
      if (new_tab?.allowMultipleTabs === false) {
        const temp_index = tabs.findIndex((t) => t.type === new_tab.type);
        if (temp_index !== -1) {
          if (new_tab.type === CONFIGURATION_TAB) {
            displayToast({
              type: "warn",
              title:
                "Configuration tab is already opened. Please close it and try again.",
            });
            setAddNewTab(null);
            return;
          }
          if (selectedIndex !== temp_index) setSelectedIndex(temp_index);
          setAddNewTab(null);
          return;
        }
      }
      updated_tabs = [
        ...updated_tabs,
        { ...new_tab, props: addNewTab.props || null },
      ];
      setTabList(updated_tabs);
      setSelectedIndex(updated_tabs.length - 1);
      setAddNewTab(null);
    }
  }, [SET_MAXIMUM_TABS, addNewTab, selectedIndex, setAddNewTab, tabs]);

  useEffect(() => {
    const req_interceptor = nodeClient.interceptors.request.use((req) => {
      req.headers = {
        ...req.headers,
        token: sessionStorage.getItem("token"),
      };
      return req;
    });
    const res_interceptor = nodeClient.interceptors.response.use(
      (response) => {
        if (response?.data?.error === 401) {
          return logoutHandler();
        }
        if (BYPASS_ERROR_URLS.indexOf(response?.config.url) !== -1) {
          setShowLoading(false);
          return response;
        }
        if (response?.data?.status !== "success") {
          displayToast({
            type: "error",
            title:
              typeof response?.data?.result === "string"
                ? response?.data?.result
                : typeof response?.data?.result === "object" &&
                  (response?.data?.result?.message ||
                    "An unexpected error occured"),
          });
          return setShowLoading(false);
        }
        setShowLoading(false);
        return response;
      },
      (error) => {
        displayToast({
          type: "error",
          title: "Something went wrong! Please try again later.",
        });
        setShowLoading(false);
      }
    );
    return () => {
      nodeClient.interceptors.response.eject(res_interceptor);
      nodeClient.interceptors.response.eject(req_interceptor);
    };
  }, [logoutHandler, setShowLoading]);

  useEffect(() => {
    getCategoyOptions();
    // getItemTypeOptions();
  }, [getCategoyOptions]);

  useEffect(() => {
    if (currentComponent?.startsWith("change_password")) {
      document.addEventListener("keyup", changePasswordKeyListener, false);
    } else {
      document.removeEventListener("keyup", changePasswordKeyListener, false);
    }
    return () => {
      document.removeEventListener("keyup", changePasswordKeyListener, false);
    };
  }, [currentComponent, changePasswordKeyListener]);

  return (
    <>
      <Loading open={showLoading} />
      <div className={classes["home"]}>
        <Tab
          tabs={tabList}
          goToNextTab={nextTab}
          goToPrevTab={prevTab}
          closeCurrentTab={closeTab}
          focusTabIndex={selectedIndex}
          closeTab={closeTabHandler}
          tabClicked={(index) => {
            setNextTab(false);
            setPrevTab(false);
            setSelectedIndex(index);
            dispatch({ type: "update_active_tab_index", payload: index });
          }}
          updatedTabs={updatedTabsHandler}
          variant="filled"
          titleBarStartItems={titleBarStartItems}
          enableTabSummary={true}
          titleBarEndItems={titleBarEndItems}
          closeTriggered={(params) => {
            setCloseTab(false);
            if (params?.triggered) {
              setCurrentComponent("common-modal");
            } else {
              setCurrentComponent(null);
            }
          }}
        />
      </div>
      {showSpotlight && <Spotlight />}
      <Modal
        open={showChangePassword}
        onClose={closeChangePasswordHandler}
        onEscape={closeChangePasswordHandler}
        header="Change Password"
        content={<ChangePassword ref={changePasswordRef} />}
        footer={
          <div style={{ paddingLeft: "1rem" }}>
            <Button
              ref={saveChangedPasswordRef}
              color="violet"
              endIcon={<Shortcut keys={["Ctrl", "S"]} />}
              label="Change Password"
              onClick={(e) => {
                const data = changePasswordRef?.current?.getFormState();
                if (!validateChangePasswordForm(data)) return;
                changeAdminPasswordHandler(data);
              }}
            />
          </div>
        }
      />
    </>
  );
};

export default Home;
